module.exports = __webpack_public_path__ + "img/descubre-seleccionado.8c1e8948.png";